import React from 'react';
import PropTypes from 'prop-types';

import SrStaticFooter, {
  SR_STATIC_FOOTER_THEME_BUYER_AGENT_FORM_PAGE,
} from 'client/components/SrStaticFooter';
import ButtonDeprecated from 'client/components/ButtonDeprecated';

const SrBuyerSideAgentFromControl = ({
  disabled,
  legend,
  noStaticFooter,
}) => {
  const buttonDOM = (
    <ButtonDeprecated
      type='submit'
      disabled={disabled}
    >
      next
    </ButtonDeprecated>
  );

  if (noStaticFooter) {
    return buttonDOM;
  }

  return (
    <>
      <SrStaticFooter theme={SR_STATIC_FOOTER_THEME_BUYER_AGENT_FORM_PAGE}>
        {buttonDOM}
        {legend}
      </SrStaticFooter>
    </>
  );
};

SrBuyerSideAgentFromControl.propTypes = {
  disabled: PropTypes.bool.isRequired,
  legend: PropTypes.node,
  noStaticFooter: PropTypes.bool,
};

SrBuyerSideAgentFromControl.displayName = 'SrBuyerSideAgentFromControl';

export default SrBuyerSideAgentFromControl;
